import { isPresent } from "@estaly/ui";

export function formatVariation(variation) {
  return isPresent(variation) ? variation : "+ ∞";
}
